import {r as d} from '@theme/theme-sections';
import {F as h} from '@theme/flickity';
import {S as m} from '@theme/slider-progress-indicator';
import {s as u} from '@theme/section-slider-lifecycle';
import '@theme/_commonjsHelpers';
const a = 'product-recommendations';
var o, l, c;
const f =
    ((c = (l = (o = window.Shopify) == null ? void 0 : o.theme) == null ? void 0 : l.sections) == null
      ? void 0
      : c.registered) || {},
  S = typeof f[a] > 'u',
  n = {slider: '[data-slider]', progressBar: '[data-slider-progress-bar]'};
S &&
  d(a, {
    ...u,
    onLoad() {
      this.teardown(), (this.sectionActive = !0), (this.slider = null), this.loadRecommendedProducts();
    },
    initSlider() {
      const e = this.container.querySelector(n.slider);
      if (!this.isSectionActive() || !e) return;
      this.destroySlider(),
        (this.slider = new h(e, {
          prevNextButtons: !0,
          pageDots: !1,
          cellAlign: 'left',
          contain: !0,
          watchCSS: !1,
          arrowShape: 'M62.5 77.6517L34.8484 50L62.5 22.3484L65.1517 25L40.1517 50L65.1517 75L62.5 77.6517Z',
        }));
      const r = this.container.querySelector(n.progressBar);
      r && (this.progressIndicator = new m({element: r, slider: this.slider})), this.scheduleSliderResize();
    },
    loadRecommendedProducts() {
      var r;
      (r = this.requestController) == null || r.abort(),
        cancelAnimationFrame(this.initFrame),
        (this.initFrame = null),
        this.destroySlider(),
        (this.requestController = new AbortController());
      const e = this.requestController;
      fetch(this.container.dataset.url, {signal: e.signal})
        .then((t) => t.text())
        .then((t) => {
          if (!this.isSectionActive() || e !== this.requestController) return;
          const s = document.createElement('div');
          s.innerHTML = t;
          const i = s.querySelector(`[data-section-id="${this.id}"]`);
          i &&
            i.innerHTML.trim().length &&
            ((this.container.innerHTML = i.innerHTML),
            (this.initFrame = requestAnimationFrame(() => {
              (this.initFrame = null), this.isSectionActive() && this.initSlider();
            })));
        })
        .catch((t) => {
          t.name !== 'AbortError' && console.warn(t);
        })
        .finally(() => {
          e === this.requestController && (this.requestController = null);
        });
    },
  });
